import { render, staticRenderFns } from "./FieldInfoTypeMaterial.vue?vue&type=template&id=2fd91581&scoped=true&"
import script from "./FieldInfoTypeMaterial.vue?vue&type=script&lang=js&"
export * from "./FieldInfoTypeMaterial.vue?vue&type=script&lang=js&"
import style0 from "./FieldInfoTypeMaterial.vue?vue&type=style&index=0&id=2fd91581&prod&scoped=true&lang=scss&"
import style1 from "./FieldInfoTypeMaterial.vue?vue&type=style&index=1&id=2fd91581&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd91581",
  null
  
)

export default component.exports